import { IParagraph, ParagraphType } from "types";

const ArticleParagraph = ({ content, type }: IParagraph) => {
  if (type === ParagraphType.IMAGE) {
    return (
      <div className="flex justify-center">
        <img src={content} alt="" />
      </div>
    );
  }

  if (type === ParagraphType.TEXT) {
    return <div className="whitespace-pre-line break-all" dangerouslySetInnerHTML={{ __html: content }} />;
  }

  return null;
};

export default ArticleParagraph;
